var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgF1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.054 512.054",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    enableBackground: "new 0 0 512.054 512.054",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#010202"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m66.221,250.968c-21.416,0-38.838,17.417-38.838,38.833s17.423,38.838 38.838,38.838 38.838-17.423 38.838-38.838-17.428-38.833-38.838-38.833zm0,58.823c-11.025,0-19.99-8.97-19.99-19.996s8.965-19.984 19.99-19.984 19.99,8.959 19.99,19.984c0,11.025-8.971,19.996-19.99,19.996z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m489.555,283.642c-12.405,0-22.499,10.094-22.499,22.499s10.094,22.493 22.499,22.493c12.405,0 22.499-10.088 22.499-22.493 0-12.405-10.094-22.499-22.499-22.499zm0,26.149c-2.014,0-3.644-1.636-3.644-3.65 0-2.014 1.63-3.65 3.644-3.65 2.014,0 3.65,1.636 3.65,3.65 0,2.014-1.636,3.65-3.65,3.65z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 338.794,
    x: 118.349,
    y: 301.95,
    height: 18.849
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "45.405,245.328 62.35,237.079 45.41,202.263 60.697,202.263 60.697,183.414 0,183.414     0,202.263 24.454,202.263   "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "137.809,245.106 154.19,228.732 164.988,228.732 164.988,209.877 146.378,209.877     118.966,237.295 118.966,269.963 137.809,269.963   "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "221.47,235.216 166.024,235.216 166.024,269.963 184.867,269.963 184.867,254.059     202.621,254.059 202.621,278.764 456.509,295.931 457.778,277.128 221.47,261.155   "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgF1);
export default __webpack_public_path__ + "static/media/f1.15769cfb646d574ca0ff5f123042b35b.svg";
export { ForwardRef as ReactComponent };